import { EmployeeAccess } from '../employee-access';

export class EmployeeAccessBuilder {
  static fromJson(json): EmployeeAccess {
    return (json)
      ? new EmployeeAccess(
        json.codePinAccess,
        json.emailPassAccess,
        json.nfcAccess,
        json.code,
        json.pin
      )
      : null;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/builders/employee-access.builder.ts